import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client/core'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import router from './router'
import { fetchCsrfToken } from './csrf'

// Create HTTP link to your Rails GraphQL endpoint
const httpLink = createHttpLink({
  uri: '/graphql',
  credentials: 'include',
})

// Middleware link to dynamically attach CSRF token
const csrfLink = setContext(async (_, { headers }) => {
  const token = await fetchCsrfToken()

  return {
    headers: {
      ...headers,
      'Content-Type': 'application/json',
      ...(token ? { 'X-CSRF-Token': token } : {}),
    },
  }
})

// Handle authentication errors globally
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (networkError && 'statusCode' in networkError && networkError.statusCode === 401) {
    if (router.currentRoute.value.path !== '/login') {
      router.push('/login')
    }
  }

  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      if (err.message === 'UNAUTHENTICATED') {
        if (router.currentRoute.value.path !== '/login') {
          router.push('/login')
        }
      }
    }
  }
})

// Create Apollo Client
const apolloClient = new ApolloClient({
  link: errorLink.concat(csrfLink).concat(httpLink),
  cache: new InMemoryCache(),
})

export default apolloClient
